import { UiComponents } from "@simulanisindia/ui";
import Sidebar from "./Sidebar";
import Header from "./Header";
import BottomNavigationBar from "../formobile/BottomNavigationBar";

const { MainLayout } = UiComponents;

const ChildrenComponent = ({ children }) => children;

const Private = ({ showSidebar, showHeader, children, isMobileView }) => {
  return (
    <>
      {!isMobileView ? (
        <MainLayout
          Header={<Header />}
          hideHeader={!showHeader}
          hideSidebar={!showSidebar}
          SideBar={<Sidebar />}
          Component={<ChildrenComponent> {children} </ChildrenComponent>}
        />
      ) : (
        <div className="mobileView">
          <BottomNavigationBar />
          <ChildrenComponent> {children} </ChildrenComponent>
        </div>
      )}
    </>
  );
};

export default Private;
